import React, { useEffect } from 'react';
import { useEntryPoint } from '@atlassian/jira-entry-point';
import { JiraEntryPointContainer } from '@atlassian/jira-entry-point-container';
import { asyncBulkopsCoreEntryPoint } from '../entrypoint';
import type { BulkOpsCoreType } from './ui';

const entryPointParams = {};
export const AsyncBulkOpsCore = (props: BulkOpsCoreType) => {
	const { entryPointActions, entryPointReferenceSubject } = useEntryPoint(
		asyncBulkopsCoreEntryPoint,
		entryPointParams,
	);

	useEffect(() => {
		entryPointActions.load();
	}, [entryPointActions]);

	return (
		<JiraEntryPointContainer
			id="jira.backlog.bulk.operations.core"
			packageName="jiraBulkOperationsCore"
			entryPointReferenceSubject={entryPointReferenceSubject}
			fallback={<></>}
			runtimeProps={props}
		/>
	);
};
